export const fixPathSlash = (pathname:string):string =>{
    if(pathname.slice(-1) === "/")return pathname.slice(0,-1);
    return pathname;
}